enum MessengerBillingType {
  CARGO = "CARGO",
  TAXI = "TAXI",
}

export default MessengerBillingType;
